export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/point.js
// module id = 91
// module chunks = 0 1 2 3 4